// components/RecaptchaField.jsx
import React from "react";
import ReCAPTCHA from "react-google-recaptcha";

const RecaptchaField = ({ onChange, siteKey, innerRef }) => {
  return (
    <div className="my-4 scale-[0.85] origin-left">
      <ReCAPTCHA
        sitekey={siteKey}
        onChange={onChange}
        ref={innerRef}
      />
    </div>
  );
};

import PropTypes from "prop-types";

RecaptchaField.propTypes = {
  onChange: PropTypes.func.isRequired,
  siteKey: PropTypes.string.isRequired,
  innerRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any })
  ]),
};


export default RecaptchaField;
